/**
 * Allow only same-app relative paths for navigate() / redirects.
 * Rejects protocol-relative URLs (`//evil.com`), schemes, and backslashes.
 */
export function safeInternalPath(
  value: string | null | undefined,
  fallback: string,
): string {
  if (!value) return fallback;
  const trimmed = value.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('\\')) {
    return fallback;
  }

  try {
    const url = new URL(trimmed, 'https://larkpm.invalid');
    if (url.origin !== 'https://larkpm.invalid') return fallback;
    if (!url.pathname.startsWith('/')) return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}
